var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stms_container"},[_c('div',{staticClass:"index_container"},[_c('iframe',{class:['d3-iframe'],attrs:{"id":"d3-iframe","src":"http://49.4.52.75:7090/smts-home","frameborder":"0"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }